/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".a-breadcrumb[_ngcontent-%COMP%], .divider[_ngcontent-%COMP%]{color:#007dc3;padding-right:5px;font-size:16px}.a-breadcrumb.active[_ngcontent-%COMP%], .divider.active[_ngcontent-%COMP%]{color:#3b3b3b}"];
export { styles as styles };
